import { ConstraintsManager } from "@/components/admin/ConstraintsManager";

export function SettingsConstraintsPage() {
  return <ConstraintsManager />;
}
